import api from '../../api'
import getConfig from '../../../config'
import { getToken } from '../../../utils/session'
const { REACT_APP_API_BASE_URI } = getConfig()

export async function getSnapshot (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'object',
    mockData: 'market-activity/closing-summary/snapshot',
    url: '/market-data/snapshot/closing',
    params
  })
  return response.data
}

export async function getMostActive (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'records',
    mockData: 'market-activity/closing-summary/most-active',
    url: '/market-data/active/closing',
    params
  })
  return response.data
}

export async function downloadMostActive (params) {
  const url = '/otcapi/download/internal/market-data/active/closing/download'
  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => params[key] && `${key}=${params[key]}`).join('&')
  let jwtToken
  await getToken()
    .then(res => {
      jwtToken = res
    })
  window.open(`${REACT_APP_API_BASE_URI}${url}?${queryString}&file=market-data-closing-most-active&token=${jwtToken}`)
}

export async function getAdvancers (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'records',
    mockData: 'market-activity/closing-summary/advancers',
    url: '/market-data/advancers/closing',
    params
  })
  return response.data
}

export async function downloadAdvancers (params) {
  const url = '/otcapi/download/internal/market-data/advancers/closing/download'
  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => params[key] && `${key}=${params[key]}`).join('&')
  let jwtToken
  await getToken()
    .then(res => {
      jwtToken = res
    })
  window.open(`${REACT_APP_API_BASE_URI}${url}?${queryString}&file=market-data-closing-advancers&token=${jwtToken}`)
}

export async function getDecliners (params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    responseFormat: 'records',
    mockData: 'market-activity/closing-summary/decliners',
    url: '/market-data/decliners/closing',
    params
  })
  return response.data
}

export async function downloadDecliners (params) {
  const url = '/otcapi/download/internal/market-data/decliners/closing/download'
  const queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => params[key] && `${key}=${params[key]}`).join('&')
  let jwtToken
  await getToken()
    .then(res => {
      jwtToken = res
    })
  window.open(`${REACT_APP_API_BASE_URI}${url}?${queryString}&file=market-data-closing-decliners&token=${jwtToken}`)
}
